module.exports = __webpack_public_path__ + "img/programme1.ad1219b8.png";